import { ListHttpResponse } from "../../../_common/models/core.model";
import { ShopModel } from "../../shops/shop.model";

export interface PrinterHistoryModel {
  printerId: number
  shop: ShopModel,
  IsActive: boolean,
  dateFrom: Date,
  dateTo: Date | null
}

export interface PrinterHistoryListResponse extends ListHttpResponse<PrinterHistoryModel> { }